export const languages = [
  { 
    code: "en",
    nativeName: "English",
  }
]
